import { ReactComponent as EmailIcon } from '../email.svg'
import InactivePanel from '../InactivePanel'
import { ReactComponent as SmsIcon } from '../sms.svg'
import StatsPanel from '../StatsPanel'
import styles from './ActionCard.module.scss'

function ActionCard({
  title,
  messagePreview,
  stats,
  isActive = true,
  hasEmailCampaign = true,
  isDisabledByPrevious = false,
  onEnable,
  onClick
}) {
  const cardClassNames = [
    styles.card,
    !isActive && styles.inactive,
    isDisabledByPrevious && styles.disabledByPrevious
  ]
    .filter(Boolean)
    .join(' ')

  const emailIconClassName = hasEmailCampaign
    ? styles.channelIcon
    : `${styles.channelIcon} ${styles.channelIconDisabled}`

  const handleClick = isDisabledByPrevious ? undefined : onClick

  return (
    <div className={cardClassNames} onClick={handleClick}>
      <div className={styles.cardContent}>
        {!hasEmailCampaign && (
          <span className={styles.emailNotConfigured}>Email not configured</span>
        )}
        <div className={styles.channelBadges}>
          <SmsIcon className={styles.channelIcon} />
          <EmailIcon className={emailIconClassName} />
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.messagePreview}>
          <p className={styles.messageText}>{messagePreview}</p>
        </div>
      </div>
      {isActive && !isDisabledByPrevious ? (
        <StatsPanel stats={stats} variant="action" />
      ) : (
        <InactivePanel
          guestCount={stats.guests}
          onEnable={onEnable}
          hideEnableButton={isDisabledByPrevious}
        />
      )}
    </div>
  )
}

export default ActionCard
